import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import SegmentNodeList from './SegmentNodeList';
import WKTWriter from '../io/WKTWriter';
import CoordinateArraySequence from '../geom/impl/CoordinateArraySequence';
import Coordinate from '../geom/Coordinate';
import Octant from './Octant';
import ArrayList from '../../../../java/util/ArrayList';
import NodableSegmentString from './NodableSegmentString';
var NodedSegmentString = /*#__PURE__*/function () {
  function NodedSegmentString() {
    _classCallCheck(this, NodedSegmentString);
    NodedSegmentString.constructor_.apply(this, arguments);
  }
  _createClass(NodedSegmentString, [{
    key: "getCoordinates",
    value: function getCoordinates() {
      return this._pts;
    }
  }, {
    key: "size",
    value: function size() {
      return this._pts.length;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this._pts[i];
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this._pts[0].equals(this._pts[this._pts.length - 1]);
    }
  }, {
    key: "getSegmentOctant",
    value: function getSegmentOctant(index) {
      if (index === this._pts.length - 1) return -1;
      return this.safeOctant(this.getCoordinate(index), this.getCoordinate(index + 1));
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this._data = data;
    }
  }, {
    key: "safeOctant",
    value: function safeOctant(p0, p1) {
      if (p0.equals2D(p1)) return 0;
      return Octant.octant(p0, p1);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._data;
    }
  }, {
    key: "addIntersection",
    value: function addIntersection() {
      if (arguments.length === 2) {
        var intPt = arguments[0],
          segmentIndex = arguments[1];
        this.addIntersectionNode(intPt, segmentIndex);
      } else if (arguments.length === 4) {
        var li = arguments[0],
          _segmentIndex = arguments[1],
          geomIndex = arguments[2],
          intIndex = arguments[3];
        var _intPt = new Coordinate(li.getIntersection(intIndex));
        this.addIntersection(_intPt, _segmentIndex);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return WKTWriter.toLineString(new CoordinateArraySequence(this._pts));
    }
  }, {
    key: "getNodeList",
    value: function getNodeList() {
      return this._nodeList;
    }
  }, {
    key: "addIntersectionNode",
    value: function addIntersectionNode(intPt, segmentIndex) {
      var normalizedSegmentIndex = segmentIndex;
      var nextSegIndex = normalizedSegmentIndex + 1;
      if (nextSegIndex < this._pts.length) {
        var nextPt = this._pts[nextSegIndex];
        if (intPt.equals2D(nextPt)) normalizedSegmentIndex = nextSegIndex;
      }
      var ei = this._nodeList.add(intPt, normalizedSegmentIndex);
      return ei;
    }
  }, {
    key: "addIntersections",
    value: function addIntersections(li, segmentIndex, geomIndex) {
      for (var i = 0; i < li.getIntersectionNum(); i++) this.addIntersection(li, segmentIndex, geomIndex, i);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [NodableSegmentString];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._nodeList = new SegmentNodeList(this);
      this._pts = null;
      this._data = null;
      var pts = arguments[0],
        data = arguments[1];
      this._pts = pts;
      this._data = data;
    }
  }, {
    key: "getNodedSubstrings",
    value: function getNodedSubstrings() {
      if (arguments.length === 1) {
        var segStrings = arguments[0];
        var resultEdgelist = new ArrayList();
        NodedSegmentString.getNodedSubstrings(segStrings, resultEdgelist);
        return resultEdgelist;
      } else if (arguments.length === 2) {
        var _segStrings = arguments[0],
          _resultEdgelist = arguments[1];
        for (var i = _segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          ss.getNodeList().addSplitEdges(_resultEdgelist);
        }
      }
    }
  }]);
  return NodedSegmentString;
}();
export { NodedSegmentString as default };